module.exports = __webpack_public_path__ + "static/media/price-user.523c0b3c.svg";